// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".gallery .slick-slide>div[data-v-61d61ffe]{outline:0}.gallery .media-wrap[data-v-61d61ffe]{outline:0;display:block!important}.gallery .media-item[data-v-61d61ffe]{pointer-events:none}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
